module.exports = __webpack_public_path__ + "static/media/user-lock.862f424b.svg";